import { ErrorCodes } from 'enums';

export class BadRequestError extends Error {
  code: ErrorCodes = ErrorCodes.BAD_REQUEST;

  constructor() {
    super('Este recurso está inacessível.');
    this.name = 'BadRequestError';

    return this;
  }
}
